<div #header class="header-container">
  <div class="header-content">
    <ng-content></ng-content>
  </div>
</div>
<div [style.margin-bottom.rem]="2" #buffer></div>
